export const DEVICE_STATUS = {
  Unknown: 'Unknown',
  Approved: 'Approved',
  Revoked: 'Revoked',
  Archived: 'Archived',
};

const DEVICE_STATUS_MAPPING = [
  { value: DEVICE_STATUS.Unknown, label: 'No Status', color: '#9E9E9E' },
  { value: DEVICE_STATUS.Approved, label: 'Approved', color: '#4CAF50' },
  { value: DEVICE_STATUS.Revoked, label: 'Revoked', color: '#F44336' },
  { value: DEVICE_STATUS.Archived, label: 'Archived', color: '#FF9800' },
];

export const getDeviceStatusLabel = value =>
  DEVICE_STATUS_MAPPING.find(item => item.value === value)?.label || 'No Status';

export const getDeviceStatusColor = value =>
  DEVICE_STATUS_MAPPING.find(item => item.value === value)?.color || '#9E9E9E';

export const getDeviceStatusOptions = () =>
  DEVICE_STATUS_MAPPING.map(({ value, label }) => ({ value, label }));
